module.exports = __webpack_public_path__ + "img/bici.436d8b18.png";